// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2c7Da","header":"PatientQuestionnaire_header__Oj9bF","info":"PatientQuestionnaire_info__g7Xki"};